<template>
  <gh-invoke ref="inv" v-model="data" module="mes.business.mdl.material.service" cls="MaterialTypeService"
    method="get_tree" :args="args" @start="" @complete="loadedData">
    <template v-slot="{args,data,loading}">
      <slot :data="data" :loading="loading">
        <v-container style="background: white" full-width fluid>
          <v-layout column>
            <v-layout row v-if="showToolbar" align-center ma-0 pa-0>
              <v-progress-linear color="success" :indeterminate="loading" v-show="loading"></v-progress-linear>
              <v-btn color="primary" outline icon @click="query">
                <v-icon>mdi-database-refresh</v-icon>
              </v-btn>
            </v-layout>
          </v-layout>
          <v-divider></v-divider>
          <gh-tree ref="tree" :draggable="true" :expanded-level="expandLevel" v-model="currentNode"
            :data="getTreeData(data)" node-key="Id" :expand-on-click-node="false" :default-expand-all="expandAll"
            @node-drop="test">
            <div slot-scope="{node,data}">
              <slot name="node" :node="node" :data="data">
                {{data.Cd}} {{data.Name}}
              </slot>

            </div>
          </gh-tree>
          <!-- <el-tree :data="" @ondrop="test"></el-tree> -->
        </v-container>

      </slot>
    </template>
  </gh-invoke>
</template>

<style scoped>

</style>

<script>
  import MaterialTypeNavigation from "./materialTypeNavigation.ts";
  export default MaterialTypeNavigation;
</script>